// extracted by mini-css-extract-plugin
export default {"root":"styles_root__VNlTQ","setup_list":"styles_setup_list__NlTva","setup_item":"styles_setup_item__GsxNH","active":"styles_active__Xddt0"};